import React, { useState } from 'react';
import { FestivalHeader, Loading } from '../controls';
import FilterableTable from '../table';
import Portal from '../modal/Portal';
import { PerformerForm } from './';
import {
  usePerformerTypesQuery,
  usePerformersQuery,
  useSavePerformerMutation,
} from '@/queries/performers';

export function Performers() {
  const performersQ = usePerformersQuery();
  const typesQ = usePerformerTypesQuery();
  const saveMutation = useSavePerformerMutation();

  const performers = performersQ.data ?? [];
  const performerTypes = typesQ.data ?? {};
  const loading =
    performersQ.isPending ||
    performersQ.isFetching ||
    typesQ.isPending ||
    typesQ.isFetching;

  const [showModal, setShowModal] = useState(false);
  const [performer, setPerformer] = useState({});

  const buildColumnDefinitions = () => {
    var columnDefs = {};
    columnDefs.performerName = {
      header: 'Performer',
      filterable: false,
      sortable: true,
      showViewLink: false,
      handleClick: true,
    };
    columnDefs.type = {
      header: 'Type',
      filterable: false,
      sortable: false,
    };
    columnDefs.hometown = {
      header: 'Hometown',
      filterable: false,
      sortable: false,
    };
    return columnDefs;
  };

  const onFileUpload = (fileInfo) => {
    const { url, filename } = fileInfo;
    setPerformer((prev) => ({
      ...prev,
      photoURL: url,
      performerPhoto: filename,
    }));
  };

  const onFileDelete = () => {
    setPerformer((prev) => ({
      ...prev,
      photoURL: null,
      performerPhoto: null,
    }));
  };

  const savePerformerAction = async (newValues) => {
    const updatedPerformer = { ...performer, ...newValues };
    try {
      await saveMutation.mutateAsync(updatedPerformer);
      setShowModal(false);
      setPerformer({});
    } catch {
      /* mutation toast */
    }
  };

  const openPerformerModal = (selectedPerformer) => {
    const next =
      performers.find((p) => p.performerId === selectedPerformer.performerId) ||
      {};
    setPerformer(next);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <FestivalHeader
        variant="bethere"
        title="My Performers"
        subtitle="These are performers you've used before. You can reuse or select them from your list the next time you create an event, or add new ones during event creation."
        showAdd={true}
        addTitle="Add Performer"
        addAction={() => {
          setPerformer({});
          setShowModal(true);
        }}
      />
      {loading ? (
        <Loading />
      ) : (
        <FilterableTable
          data={performers}
          tableTitle=""
          columns={buildColumnDefinitions()}
          includeFilter={false}
          editHandler={openPerformerModal}
          toggleModal={() => {
            setShowModal(true);
            setPerformer({});
          }}
        />
      )}

      <Portal
        header={
          performer
            ? performer.performerName || 'Add New Performer'
            : 'Add New Performer'
        }
        open={showModal}
        onClose={closeModal}
      >
        <PerformerForm
          performer={performer}
          performerTypes={performerTypes}
          handleSave={savePerformerAction}
          onFileUpload={onFileUpload}
          onFileDelete={onFileDelete}
        />
      </Portal>
    </>
  );
}
